import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

export default function Modal({ children, open, ...props }) {
  const dialog = useRef();
  useEffect(() => {
    if (open) {
      dialog.current.showModal();
      document.body.style.overflow = "hidden"; // 스크롤 비활성화
    } else {
      dialog.current.close();
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = ""; // 컴포넌트가 언마운트 될 때 스크롤 원상 복구
    };
  }, [open]);
  return createPortal(
    <dialog ref={dialog} {...props}>
      {children}
    </dialog>,
    document.getElementById("modal")
  );
}
